import { render } from "./WhitelabelCareCards.vue?vue&type=template&id=0a0feba6&scoped=true&ts=true"
import script from "./WhitelabelCareCards.vue?vue&type=script&lang=ts"
export * from "./WhitelabelCareCards.vue?vue&type=script&lang=ts"

import "./WhitelabelCareCards.vue?vue&type=style&index=0&id=0a0feba6&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0feba6"]])

export default __exports__